import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { truncate } from 'lodash';
import { Link } from '@mui/material';

import * as routes from 'router/routes';
import { useBreakpointFlags } from 'hooks/useBreakpointFlags';
import { DashboardBox, NoData, TitleTooltip } from 'components/simple';
import { RadialChart } from 'components/charts';

const styles = {
  dashboardBox: {
    height: 250,
    backgroundColor: 'white',
  },
  dashboardContent: {
    height: 180,
    minHeight: 'unset !important',
  },
  radialChart: {
    position: 'relative',
    top: -20,
  },
  header: ({ breakpoints }) => ({
    [breakpoints.up('md')]: {
      height: 70,
    },
  }),
  chartName: { wordBreak: 'break-word' },
  noData: { border: 'none' },
};

export const DashboardPortfolioRadialChart = ({ chartData: { id, projectName, performance }, organisationId }) => {
  const { getResponsiveValueForCurrent } = useBreakpointFlags();
  const titleLength = getResponsiveValueForCurrent({
    xs: 30,
    sm: 35,
    md: 40,
    lg: 50,
    xl: 55,
    xxl: 70,
  });

  return (
    <DashboardBox
      customStyles={styles.dashboardBox}
      customContentStyles={styles.dashboardContent}
      customHeaderStyles={styles.header}
      custom={() => (
        <TitleTooltip titleLength={titleLength} title={projectName}>
          <Link
            component={RouterLink}
            to={{
              pathname: `/${organisationId}/${routes.dashboard}/${id}`,
              state: { backTo: `${routes.dashboardPortfolio}/${organisationId}` },
            }}
            variant="body2-bold"
            underline="none"
            textAlign="center"
            sx={styles.chartName}
          >
            {truncate(projectName, { length: titleLength })}
          </Link>
        </TitleTooltip>
      )}
    >
      {performance ? (
        <RadialChart
          value={performance}
          innerRadius={100}
          outerRadius={170}
          chartContainerHeight={150}
          barSize={80}
          chartContainerStyles={styles.radialChart}
        />
      ) : (
        <NoData sx={styles.noData} />
      )}
    </DashboardBox>
  );
};

DashboardPortfolioRadialChart.propTypes = {
  chartData: PropTypes.shape({
    id: PropTypes.string.isRequired,
    projectName: PropTypes.string.isRequired,
    performance: PropTypes.number.isRequired,
  }).isRequired,
  organisationId: PropTypes.string.isRequired,
};
